module.exports = __webpack_public_path__ + "static/media/regisrec.0642c0f3.jpg";